export default "__VITE_ASSET__FQVhVcHp__"